import React from 'react'
import Retour from '../components/Retour'

function Montagne() {
  return (
    <div>
         <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Pierre, ingénieur parisien, se rend dans les Alpes pour son travail. Irrésistiblement attiré par les montagnes, il s’installe un bivouac en altitude et décide de ne plus redescendre. Là-haut, il fait la rencontre de Léa et découvre de mystérieuses lueurs.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
    </div>
    </div>
  )
}

export default Montagne